import { AppBar, ToggleThemeButton } from 'react-admin'
import { Typography, Box, Select, MenuItem, FormControl } from '@mui/material'
import { Business } from '@mui/icons-material'
import { darkTheme, lightTheme, propticaDarkTheme, propticaLightTheme } from './themes'
import { CustomUserMenu } from './UserMenu'
import { version } from '../helpers'
import { Link } from 'react-router-dom'
import { useIndustry } from '../context/IndustryContext'
import './styles/fonts.css'

const HempBranding = () => (
   <>
      <img src="static/industry/hemp/header_icon_120x75.png" alt="AffsMedia" style={{width: '50px'}}/>
      <span className="app-bar-header-title">AffsMedia</span>
      <i style={{color: '#8D1A88', fontSize: '25px', marginBottom: '5px'}}>Analytics</i>
   </>
);

const PropBranding = () => (
   <img src="static/industry/prop/Proptica Logo Design Blue Trim.png" alt="Proptica" style={{height: '40px'}}/>
);

export const CustomAppBar = (props) => {
   const { industries, industryId, switchIndustry, loading } = useIndustry();

   const handleIndustryChange = (e) => {
      const newId = Number(e.target.value);
      if (newId !== industryId) {
         switchIndustry(newId);
      }
   };

   return (
      <AppBar {...props} userMenu={<CustomUserMenu/>} elevation={1} color="inherit">
         <Typography
            variant="h6"
            color="inherit"
            sx={{
               flex: 1,
               textOverflow: 'ellipsis',
               whiteSpace: 'nowrap',
               overflow: 'hidden',
            }}
            id="react-admin-title"
         />
         {industryId === 2 ? <PropBranding /> : <HempBranding />}
         <Box component="span" sx={{flex: 1}}/>
         {!loading && industries.length > 0 && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mr: 2 }}>
               <Business sx={{ fontSize: 24 }} />
               <Typography variant="h6">Industry</Typography>
               <FormControl size="small" sx={{ ml: 1, minWidth: 140 }}>
                  <Select
                     value={industryId || ''}
                     onChange={handleIndustryChange}
                     variant="outlined"
                     sx={{ height: 32 }}
                  >
                     {industries.map((industry) => (
                        <MenuItem key={industry.id} value={industry.id}>
                           {industry.name.charAt(0).toUpperCase() + industry.name.slice(1)}
                        </MenuItem>
                     ))}
                  </Select>
               </FormControl>
            </Box>
         )}
         <div className="row-fluid">
            <div className="text-center"><Link to="/history">{version}</Link></div>
         </div>
         <ToggleThemeButton
            lightTheme={industryId === 2 ? propticaLightTheme : lightTheme}
            darkTheme={industryId === 2 ? propticaDarkTheme : darkTheme}
         />
      </AppBar>
   )
}
